import {
  Box,
  Button,
  Grid,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import React, { useEffect } from "react";
import StarIcon from "@mui/icons-material/Star";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useNavigate, useParams } from "react-router-dom";
import AddressCard from "../adreess/AdreessCard";
import { deepPurple } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { getOrderById } from "../../../Redux/Customers/Order/Action";
import BackdropComponent from "../BackDrop/Backdrop";
import { cancelOrder } from "../../../Redux/Admin/Orders/Action";

const OrderDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderId } = useParams();
  const { order } = useSelector((store) => store);

  useEffect(() => {
    if (!orderId) return;
    dispatch(getOrderById(orderId));
  }, [orderId, dispatch]);

  const handleCancel = () => {
    dispatch(cancelOrder(orderId));
  };

  return (
    <>
      {!order.loading && (
        <Box className="px-2 lg:px-36 py-5 space-y-8">
          {/* Delivery Address Section */}
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Delivery Address
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <AddressCard address={order.order?.shippingAddress} />
              </Grid>
            </Grid>
          </Paper>

          {/* Action Buttons Section */}
          <Paper elevation={3} sx={{ p: 3 }}>
            <Grid container sx={{ justifyContent: "flex-end", alignItems: "center" }}>
              <Grid item xs={12} md="auto" sx={{ display: "flex", gap: 1.5 }}>
                {order.order?.awbNo && (
                  <Button
                    variant="contained"
                    startIcon={<LocalShippingIcon />}
                    sx={{
                      backgroundColor: deepPurple[500],
                      "&:hover": { backgroundColor: deepPurple[700] },
                    }}
                    onClick={() => navigate(`/account/order/${orderId}/track`)}
                  >
                    Track Shipment
                  </Button>
                )}
                {order.order?.orderStatus === "DELIVERED" ? (
                  <Button variant="contained" color="error">
                    RETURN
                  </Button>
                ) : (
                  <Button variant="outlined" sx={{ borderColor: deepPurple[500], color: deepPurple[500] }} onClick={handleCancel}>
                    Cancel Order
                  </Button>
                )}
              </Grid>
            </Grid>
          </Paper>

          {/* Order Items Section */}
          <Grid container spacing={3}>
            {order.order?.orderItems.map((item) => (
              <Grid item xs={12} key={item.product._id}>
                <Paper elevation={3} sx={{ p: 3, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={item?.product?.colorVariants?.[0]?.images?.find((img) => img?.label === "front")?.url}
                      alt={item.product.title}
                      style={{ width: "80px", height: "80px", objectFit: "cover" }}
                    />
                    <Box sx={{ ml: 3 }}>
                      <Typography variant="subtitle1" sx={{ color: deepPurple[500], fontWeight: "bold" }}>
                        Order Number: {order?.order?.orderNumber || "N/A"}
                      </Typography>
                      <Typography variant="body1">{item?.product?.title}</Typography>
                      <Typography variant="body2">Seller: {item?.product?.brand}</Typography>
                      <Typography variant="body2">₹{item?.product?.price}</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                    onClick={() => navigate(`/account/rate/${item.product._id}`)}
                  >
                    <StarIcon sx={{ fontSize: "2rem", color: deepPurple[500] }} />
                    <Typography variant="body1" sx={{ ml: 1, color: deepPurple[500] }}>
                      Rate & Review
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <BackdropComponent open={order.loading} />
    </>
  );
};

export default OrderDetails;
